import React from 'react';
import SbEditable from 'storyblok-react';
import { render } from 'storyblok-rich-text-react-renderer';

type Props = {
  blok: TextArea;
};
const SupportText: React.FC<Props> = ({ blok }) => {
  return (
    // @ts-expect-error require storyblok-react upgrade
    <SbEditable key={blok._uid} content={blok}>
      <div className="rich-text-content col-span-12 pb-2">
        {blok.text && render(blok.text)}
      </div>
    </SbEditable>
  );
};

export default SupportText;
